import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layout
import Header from '../Header/Header';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';

// Public Pages
import Home from '../../pages/Home/Home';
import About from '../../pages/About/About';
import Contact from '../../pages/Contact/Contact';
import Jobs from '../../pages/Jobs/Jobs';
import Error404 from '../../ErrorPages/Error404/Error404';
import Login from '../../pages/Members/Login';
import Register from '../../pages/Members/Membership_Register';

// Protected Pages
import Dashboard from '../../Portal/Dashboard';
import PrivateRoute from '../../Auth/PrivateRoute';

const Router = () => {
  return (
    <>
      <Header />
      <Navbar />

      <main>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/membership_register" element={<Register />} />

          {/* Protected Routes */}
        

          {/* Catch-all 404 */}
          <Route path="*" element={<Error404 />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
};

export default Router;
